module.exports = "https://trybtryb-legacy.web.app/img/pencil.0da7d79f.svg";